import React from "react";
import { MessageCircle, Mail, MapPin, Clock, Instagram } from "lucide-react";
import BulkEnquiryForm from "../components/BulkEnquiryForm";
import { WHATSAPP_DISPLAY, BRAND_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, buildWhatsAppLink } from "../lib/api";

export default function Contact() {
  const waLink = buildWhatsAppLink("Hi I'm Ube team, I'd like to enquire about bulk Ube powder.");
  return (
    <div className="bg-[#FCFAF8]" data-testid="contact-page">
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-b from-[#F3EFEA] to-[#FCFAF8]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 text-center">
          <div className="eyebrow mb-3">Get in touch</div>
          <h1 className="font-display text-5xl md:text-6xl text-[#1A1A1A] mb-4">
            Let's <em className="text-[#4B0082]">talk Ube.</em>
          </h1>
          <p className="text-lg text-[#555] max-w-2xl mx-auto">
            Whether you're a cafe owner, bakery brand, ice-cream founder, or HORECA buyer — our team responds within 24 hours.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 space-y-6">
            <a href={waLink} target="_blank" rel="noreferrer" className="block surface-card p-7 cursor-pointer" data-testid="contact-whatsapp-card">
              <div className="h-11 w-11 rounded-xl bg-[#25D366]/10 flex items-center justify-center text-[#25D366] mb-4">
                <MessageCircle size={20} />
              </div>
              <h3 className="font-display text-xl mb-2">WhatsApp (fastest)</h3>
              <span className="text-[#4B0082] font-medium block" data-testid="contact-whatsapp-number">{WHATSAPP_DISPLAY}</span>
              <p className="text-xs text-[#888] mt-2">Tap anywhere on this card to chat · Avg reply &lt; 30 min, Mon–Sat.</p>
            </a>
            <a href={`mailto:${BRAND_EMAIL}`} className="block surface-card p-7" data-testid="contact-email-card">
              <div className="h-11 w-11 rounded-xl bg-[#4B0082]/10 flex items-center justify-center text-[#4B0082] mb-4">
                <Mail size={20} />
              </div>
              <h3 className="font-display text-xl mb-2">Email</h3>
              <span className="text-[#4B0082] font-medium" data-testid="contact-email">{BRAND_EMAIL}</span>
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="block surface-card p-7" data-testid="contact-instagram-card">
              <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] flex items-center justify-center text-white mb-4">
                <Instagram size={20} />
              </div>
              <h3 className="font-display text-xl mb-2">Instagram</h3>
              <span className="text-[#4B0082] font-medium" data-testid="contact-instagram">{INSTAGRAM_HANDLE}</span>
            </a>
            <div className="surface-card p-7">
              <div className="h-11 w-11 rounded-xl bg-[#D4AF37]/15 flex items-center justify-center text-[#B5952F] mb-4">
                <MapPin size={20} />
              </div>
              <h3 className="font-display text-xl mb-2">Headquarters</h3>
              <p className="text-[#555]" data-testid="contact-hq">Surat, Gujarat · Pan-India shipping</p>
            </div>
            <div className="surface-card p-7">
              <div className="h-11 w-11 rounded-xl bg-[#4B0082]/10 flex items-center justify-center text-[#4B0082] mb-4">
                <Clock size={20} />
              </div>
              <h3 className="font-display text-xl mb-2">Business hours</h3>
              <p className="text-[#555]">Mon–Sat · 10 AM – 7 PM IST</p>
            </div>
          </div>
          <div className="lg:col-span-3 bg-white border border-[#E5E0D8] rounded-3xl p-8 md:p-10 shadow-xl">
            <h2 className="font-display text-3xl text-[#1A1A1A] mb-2">Send us your enquiry</h2>
            <p className="text-[#666] mb-8">All bulk Ube Powder orders & partnership requests below.</p>
            <BulkEnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}
